<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="general" title="User texts">
          <v-btn small color="general" dark class="mb-2" @click="reload()">
            Reload
          </v-btn>
          <v-btn small color="general" dark class="mb-2" @click="runall()">
            Run
          </v-btn>
          <!--
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            width="400"
          ></v-text-field>
          -->
          <v-data-table
            :headers="headers"
            :items="testset"
            :items-per-page="50"
            :search="search"
            disable-pagination
            dense
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item[1] }}</td>
              <td>{{ item[2] }}</td>
              <td :class="[item[2] == item[3] ? 'valid' : 'invalid']">
                {{ item[3] }}
              </td>
              <td class="text-xs-right">
                <v-icon small dark @click="run(item[0])">
                  repeat
                </v-icon>
              </td>
              <td class="text-xs-right">
                <v-icon small dark @click="runnext(item[0], 10)">
                  forward_10
                </v-icon>
              </td>
              <td class="text-xs-right">
                <v-icon small dark @click="runnext(item[0], 30)">
                  forward_30
                </v-icon>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="infoSnackbar"
      :timeout="infoTimeout"
      color="info"
    >
      {{ infoText }}
      <v-btn
        text
        @click="infoSnackbar = false"
      >
        OK
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "NLPTester",
  data() {
    return {
      search: '',
      errorText: "Error occured!",
      errorSnackbar: false,
      errorTimeout: 3000,
      infoText: "Info",
      infoSnackbar: false,
      infoTimeout: 5000,
      testerUri: '',
      headers: [
        {
          sortable: false,
          text: "Text",
          value: "name"
        },
        {
          sortable: true,
          text: "Expected intent",
          value: "country"
        },
        {
          sortable: true,
          text: "NLP Intent",
          value: "city"
        }
      ],
      testset: [
        [0, "text 1", "int_neco", "int_neco", "repeat"],
        [1, "text 1", "int_neco", "int_neco", "repeat"],
        [2, "text 1", "int_neco", "int_neco", "repeat"],
        [1, "text 1", "int_neco", "int_neco", "repeat"],
        [1, "text 1", "int_neco", "int_neco", "repeat"],
        [1, "text 1", "int_neco", "int_neco", "repeat"],
        [1, "text 1", "int_neco", "int_neco", "repeat"],
        [1, "text 1", "int_neco", "int_neco", "repeat"],
        [1, "text 1", "int_neco", "int_neco", "repeat"],
        [4, "text 4", "int_neco", "int_jineho", "repeat"]
      ]
    };
  },
  mounted() {
    var ws_uri
    var tester_uri
    if (this.location.protocol === "https:") {
        ws_uri = "wss:";
        tester_uri = "https:"
    } else {
        ws_uri = "ws:";
        tester_uri = "http:"
    }
    ws_uri += "//" + this.location.host + "/api/tester";
    this.testerUri = tester_uri + "//" + this.location.host + "/api/tester"
    this.ws = new WebSocket(ws_uri + "/intent");
    this.ws.onmessage = event => {
      let e = event;
      //alert(JSON.stringify(e.data));
      let data = JSON.parse(e.data);
      let row = this.testset[data.id];
      try {
        row[3] = data.innvisi.intent.type;
      } catch (e) {
        row[3] = "N/A";
      }
      //row[3] = e.data;
      this.testset.splice(data.id, 1, row);
      //alert(JSON.stringify(e.data));
    };
    // load from server
    this.$http
      .get("/api/tester/testset")
      .then(response => {
        this.testset = response.data;
      })
      .catch(error => {
        alert(error);
      });
  },
  methods: {
    showInfo(text) {
      this.infoText = text
      this.infoSnackbar = true
    },
    reload() {
      this.$http
        .get("/api/tester/reload")
        .then(response => {
            this.showInfo("Test data reloaded!");
        })
        .catch(error => alert(error));
    },
    run(idx) {
      this.ws.send(
        JSON.stringify({
          text: this.testset[idx][1],
          id: idx
        })
      );
    },
    run2(idx) {
      this.$http
        .post(this.testerUri + "/testintent", {
          text: this.testset[idx][1],
          id: idx
        })
        .then(response => {
          alert(JSON.stringify(response));
        })
        .catch(error => {
          alert(error);
        });
      this.testset.splice(idx, 1, [idx, "t", "int_neco", "int_jiny", "repeat"]);
    },
    runall() {
        this.runnext(0, this.testset.length)
    },
    runnext(idx, next) {
      var count = 1;
      for (var i = idx; i < idx + next; i++) {
        var self = this;
        setTimeout(function (x) {   
            self.run(x);
        }, 500 * count, i);
        count++;
      } 
    }
  }
};
</script>
<style>
.valid {
  color: #a1ffa7;
}
.invalid {
  color: #ffa6aa;
}
</style>
